import { Currency } from "@redotech/money/currencies";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

const monthlyProjectionDataPoint = z.object({
  month: z.string(),
  actualCumulativeRevenue: z.number().optional(),
  projectedCumulativeRevenue: z.number().optional(),
  projectionLowerBound: z.number().optional(),
  projectionUpperBound: z.number().optional(),
});

export const getImpactDashboardMetrics = {
  name: "getImpactDashboardMetrics" as const,
  input: z.null(),
  output: z.object({
    totalRevenueLift: z.number(),
    actualRevenueLiftFromAbTests: z.number(),
    annualizedRevenueLift: z.number(),
    checkoutConversionRate: z.number().optional(),
    averageShippingRevenuePerOrder: z.number().optional(),
    monthlyProjectionData: z.array(monthlyProjectionDataPoint),
    currency: createEnum(Currency),
  }),
};
